import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'
import QueryStringBuilder from '../../utilities/querystring-builder'

const fetchUsers = ({
    rolesCode='s',
    offset=0,
    limit=20,
    searchString = '',
    gradYearMinimum='',
    gradYearMaximum=''
}) => {
    const queryStringBuilder = new QueryStringBuilder()
    queryStringBuilder.addParam('r', rolesCode)
    queryStringBuilder.addParam('offset', offset)
    queryStringBuilder.addParam('limit', limit)
    queryStringBuilder.addParam('s', searchString)
    queryStringBuilder.addParam('gymin', gradYearMinimum)
    queryStringBuilder.addParam('gymax', gradYearMaximum)
    
    let url = urlGenerator.users() + queryStringBuilder.toString()

    return axios.get(url, createRequestConfig()).then(property('data'))
}

export default fetchUsers